/**
 * One-shot HTTP probe used to sniff a remote asset's MIME type from its
 * leading bytes. The caller already has a signed URL (no auth header needed);
 * we just need a tiny Range request to recover from a wrong declared
 * Content-Type. CORS/network/416 failures are non-fatal — the caller falls
 * back to the declared type. Lives in `infrastructure/api/` so component code
 * doesn't hit the network directly.
 */
export async function probeMimeBytes(url: string, probeBytes: number): Promise<Uint8Array | null> {
  try {
    const response = await fetch(url, {
      headers: { Range: `bytes=0-${probeBytes - 1}` },
    });
    if (!response.ok && response.status !== 206) return null;
    const buffer = await response.arrayBuffer();
    return new Uint8Array(buffer);
  } catch {
    return null;
  }
}
